import { useGenerateUploadCustomEventFileUrlMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useGenerateUploadCustomEventFileUrl() {
  const [mutation, { loading, data, error }] = useGenerateUploadCustomEventFileUrlMutation();

  const [generateUploadCustomEventFileUrl, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "generateUploadCustomEventFileUrl",
    },
    {
      hideMessage: true,
    }
  );

  return [generateUploadCustomEventFileUrl, context] as const;
}
